module.exports = __webpack_public_path__ + "media/images/toggle_destinations-ae2a8a1f7113a482c62e733672563d1a.svg";